headerHandler = {
	$headerCloseButton = $('.header-close-button'),
	$navItem = $('.nav-item'),
	$smallNavButton = $('.open-small-nav'),
	$smallNavContainer = $('.small-nav-container'),
	$flipContainer = $('.flipcard-container'),
	$navFlipCard = $('.nav-flipcard'),
	$flipCardNav = $('.flipcard-nav'),
	$headerLogoText = $('.header-logo-text'),
	$headerLogo = $('.header-logo'),
	$csHeaderScrollLimit = 200,
	$homeHeaderScrollLimit = 2400,
	$headerScrollLimit = 1200,
	$hideNavAt = 800,

	headerLogoSmaller = function() {
		var self = this;
		if (Foundation.MediaQuery.only('small')) {
			
			var limit = self.$headerScrollLimit;
			if ($('header').hasClass('front-page')) { 
				limit = self.$homeHeaderScrollLimit;
			}

			self.$headerLogoText.find('img').each(function() {
				/*
				var rightCount = 0;
				var currRight = $(this).css('right');
				currRight = currRight.replace('px', '');
				currRight = currRight.replace('%', '');

				if ($(window).scrollTop() <= limit || currRight == 0) {
					if ($(window).scrollTop() > 0) {
						rightCount = ($(window).scrollTop() / limit) * 100;
					}

					if (rightCount > 95) {
						rightCount = 100;
					}

					$(this).css({
						'right' : rightCount+'%',
					});
				}
				*/
			});
		}
	},

	lightOrDark = function(selector) {
		var color = $(selector).css('background-color');
		// Check the format of the color, HEX or RGB?
		if (color.match(/^rgb/)) {
			// If HEX --> store the red, green, blue values in separate variables
			color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

			r = color[1];
			g = color[2];
			b = color[3];
		} 
		else {
			// If RGB --> Convert it to HEX: http://gist.github.com/983661
			color = +("0x" + color.slice(1).replace( 
				color.length < 5 && /./g, '$&$&'
			));

			r = color >> 16;
			g = color >> 8 & 255;
			b = color & 255;
		}

		if (color[1] == 0 && color[2] == 0 && color[3] == 0) {
			var grad = $(selector).css('background-image');
			
			if (grad && grad !== 'none') {
				var [gradColor] = grad.matchAll(/rgb(?:b)?\((.+?)\)/g);
				color = gradColor[0].match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
			} else {
				return 'dark';
			}
		}

		// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
		hsp = Math.sqrt(
			0.299 * (r * r) +
			0.587 * (g * g) +
			0.114 * (b * b)
		);

		// Using the HSP value, determine whether the color is light or dark
		if (hsp > 127.5) {
			return 'light';
		} else {
			return 'dark';
		}
	},

	init = function(){
		var self = this;

		self.headerLogoSmaller();

		self.$headerCloseButton.on('click', function(e) {
			e.preventDefault();
			var currUrl = window.location.href;
			window.history.back(); 

			setTimeout(() => {
				if (currUrl == window.location.href) {
					url = window.location.protocol + '//' + window.location.hostname; 
					location.replace(url); 
				}
			}, 200);
		});

		if ($('header').hasClass('front-page')) {
			self.$navItem.on('click', function(e) {
	
				var url = $(this).attr("href");
				if (url && url.includes('#')) {
					url = url.replace('/', '');
					if ($(url).length !== 0) {
						e.preventDefault();
						//homeHandler.scrollTo(url);
					}
				}
			});
		}

		self.$smallNavButton.on('click', function(e) {
			e.preventDefault();

			if ($(this).hasClass('is-active')) {
				$(this).removeClass('is-active');
			} else {
				$(this).addClass('is-active');
			}

			if (self.$smallNavContainer.hasClass('show-nav')) {
				self.$smallNavContainer.removeClass('show-nav');
			} else {
				self.$smallNavContainer.addClass('show-nav');
			}
		});

		self.$navFlipCard.on('click', function(e) {
			self.$flipContainer.removeClass('is-section');
			self.$flipContainer.removeClass('hide-nav');

			
			if (Foundation.MediaQuery.only('small')) {
				self.$smallNavButton.click();
			}
		});

		$(window).scroll(function(){
			if (!$('header').hasClass('reveal-open')) {
				self.headerLogoSmaller();
			
				if (Foundation.MediaQuery.atLeast('medium')) {
					self.$headerLogo.each(function() {
						if ($(window).scrollTop() > self.$csHeaderScrollLimit) {
							if (!$(this).hasClass('smaller')) {
								$(this).addClass('smaller');
							}
						} else {
							if ($(this).hasClass('smaller')) {
								$(this).removeClass('smaller');
							}
						}
					});
				}
	
				if ($('header').hasClass('front-page')) {
					if ($(window).scrollTop() > 100) {
						if (!self.$flipContainer.hasClass('hide-nav')) {
							self.$flipContainer.addClass('hide-nav');
						}                    
						self.$headerLogoText.addClass('hide-nav');

					} else if($(window).scrollTop() < 100) {
						if (self.$flipContainer.hasClass('hide-nav')) {
							self.$flipContainer.removeClass('hide-nav');
						}
						self.$headerLogoText.removeClass('hide-nav');
					}
		
					$('.section').each(function () {
						if ($(document).scrollTop() >= $(this).position().top  && $(document).scrollTop() < $(this).position().top + $(this).outerHeight()) {
							var id = $(this).attr('id');
							var parentId = $(this).data('parent-id');
							var currSect = self.$navFlipCard.data('curr-section');
							
							var idValue = (id) ? id : parentId;
	
							var brightness = ($(this).hasClass('full-image-content')) ? 'light' : self.lightOrDark($(this).parent());
														
							if (brightness == 'dark' || $(this).hasClass('full-image-content')) {
								if (Foundation.MediaQuery.atLeast('medium')) {
									$('.header-logo.light-mode').addClass('hide');
									$('.header-logo.normal-mode').removeClass('hide');
								} else {
									$('.header-logo-icon>.icon-light').addClass('hide');
									$('.header-logo-icon>.icon-normal').removeClass('hide');
									$('.header-logo-text>.text-light').addClass('hide');
									$('.header-logo-text>.text-normal').removeClass('hide');
								}
							} else if (brightness == 'light') {
								if (Foundation.MediaQuery.atLeast('medium')) {
									$('.header-logo.normal-mode').addClass('hide');
									$('.header-logo.light-mode').removeClass('hide');
								} else {
									$('.header-logo-icon>.icon-light').removeClass('hide');
									$('.header-logo-icon>.icon-normal').addClass('hide');
									$('.header-logo-text>.text-light').removeClass('hide');
									$('.header-logo-text>.text-normal').addClass('hide');
								}
							}
	
							if ((id && currSect != id) || (parentId && currSect != parentId)) {
								self.$flipContainer.removeClass('is-section');
								self.$navFlipCard.text(idValue);
								setTimeout(function() {
									self.$flipContainer.addClass('is-section');
								}, 150);
								self.$navFlipCard.data('curr-section', idValue);    
							} else if (!id && !parentId) {
								self.$navFlipCard.text('');
								self.$flipContainer.removeClass('is-section');
								self.$navFlipCard.data('curr-section', '');
							}
	
							if (Foundation.MediaQuery.only('small')) {
								if (self.$smallNavContainer.hasClass('show-nav')) {
									self.$smallNavButton.click();
								}
							}
						}
					});
				}
			}
		});

		$("#footer-logo").on("click", function() {
			if ($('body').hasClass('home')) {
				$('html,body').animate({scrollTop: 0}, 250);
			} else {
				document.location = '/';
			}
		})
	}
}